import { render, staticRenderFns } from "./PrimeiroAcesso.vue?vue&type=template&id=8301f28e&scoped=true&"
import script from "./PrimeiroAcesso.vue?vue&type=script&lang=js&"
export * from "./PrimeiroAcesso.vue?vue&type=script&lang=js&"
import style0 from "./PrimeiroAcesso.vue?vue&type=style&index=0&id=8301f28e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8301f28e",
  null
  
)

export default component.exports